const localFlagContext = require.context('@/assets/flags', false, /\.(png|webp|jpe?g|svg)$/i);

const localFlagMap = localFlagContext.keys().reduce((acc, key) => {
  const normalizedKey = key.replace('./', '').toLowerCase();
  const baseName = normalizedKey.replace(/\.(png|webp|jpe?g|svg)$/i, '');
  acc[baseName] = localFlagContext(key);
  return acc;
}, {});

export function resolveLocalFlagAsset(countryCode = '') {
  const normalizedCode = String(countryCode || '').trim().toLowerCase();
  if (!normalizedCode) return '';
  return localFlagMap[normalizedCode] || '';
}

export function listAvailableLocalFlags() {
  return Object.keys(localFlagMap).sort();
}
